module.exports = __webpack_public_path__ + "static/cosa-logo-9659eab08207db87fd76a4702a199fc0.png";